import styled from 'styled-components'

const TwoStepPaymentFormStepButtonTextUi = styled.span`
  font-weight: bold;
  font-size: 18px;
`

export default TwoStepPaymentFormStepButtonTextUi
